define(['jquery'], function($) {
	var $window = $(window);
	var $document = $(document);
	var $header = $('header');
	var $body = $('body');
	var $item = $('[data-role="stick-to-header"]');
	var fixScrollToSection = function() {

		if($document.scrollTop() > ($item.offset().top - $header.outerHeight())) {
			$item.addClass('fixed');
			$body.css('padding-top', $item.outerHeight() + "px");
		} else {
			$item.removeClass('fixed');
			$body.css('padding-top', "0px");
		}
	};

	if($item.length) {
		//$window.scroll(fixScrollToSection);
		//$window.resize(fixScrollToSection);
		fixScrollToSection();
	}
});